export default __webpack_public_path__ + "static/media/sidebar-2.0f8bb345.jpg";